import { useEffect, useRef, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { AtvMessageDataType } from "@/api/AtvMessageApi";
import { FetchResponse } from "@/api/ApiClient";
import moment from "moment";
import { renderEDocumentStatusOffCanvasTrigger } from "@utils/ModelIndexUtils";
import { formatMoneyValue } from "@utils/Currency";
import { ExpenseFormDataKeys } from "@/generated/ExpenseFormDataKeys";
import { ExpenseRelatedAttributes } from "@/formTypes/ExpenseDataType";
import { ExpenseApi, ExpenseDataType } from "@/api/ExpenseApi";

const AtvMessageListByExpenseId = () => {
  const params = useParams()
  const { expenseId } = params;
  const modelRef = useRef<ModelIndexHandle>(null);
  const [expenseData, setExpenseData] = useState<ExpenseDataType>({});

  useEffect(() => {
    loadExpense()
  }, [expenseId]);

  const loadExpense = async () => {
    if (expenseId) {
      const selectionSet = [
        ...ExpenseFormDataKeys.filter(k => !ExpenseRelatedAttributes.includes(k)),
        "currency.*",
        "expenseCategory.*"
      ]
      const expense = await ExpenseApi.get(expenseId, { selectionSet });
      setExpenseData(expense)
      setTimeout(() => {
        modelRef?.current?.refetch()
      });
    } else {
      alert("No fue posible cargar la informacion del gasto")
    }
  }

  const getAtvMessages = async (): Promise<FetchResponse<AtvMessageDataType>> => {
    return {
      items: expenseData?.atvMessages || []
    }
  }

  return (
    <PageContainer
      title={`Lista de Mensajes ATV de Gasto #${expenseData.sequence || ""}`}
      backUrl={`/user/expenses`}
    >
      <ModelIndex<AtvMessageDataType>
        ref={modelRef}
        fetchData={() => getAtvMessages()}
        primaryProperties={[
          {
            key: "sequence",
            highlighted: true,
            className: styles.sequence
          },
          {
            key: (d) => d.provider?.nombre || "",
            alignment: "Start"
          },
        ]}
        primaryPropertiesSizing={
          [
            { sm: "4", xs: "12" },
            { sm: "8", xs: "12" }
          ]
        }
        secondaryProperties={[
          {
            key: (data) => {
              const date = moment(data.createdAt, "YYYY-MM-DD")
              return date.format("DD-MM-YYYY")
            },
            title: "Fecha",
          },
          {
            key: (data) => renderEDocumentStatusOffCanvasTrigger(data),
            title: "Estado ATV"
          },
          {
            key: (data) => {
              return formatMoneyValue(data.totalFactura, 1)
            },
            title: "Total",
            highlighted: true
          }
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "2" },
            { sm: "4", md: "3" },
            { sm: "4", md: "2" }
          ]
        }
      >
      </ModelIndex>
    </PageContainer >
  );
}

export default AtvMessageListByExpenseId;
